import styled from "styled-components";

export const Content = styled.div`
  width: 100vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: white;
`;

export const AdminSection = styled.section`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 50px 250px;
  background-color: rgb(9, 41, 61);

  @media (max-width: 1300px) {
    padding: 50px 100px;
  }

  @media (max-width: 650px) {
    padding: 20px;
  }

  h1 {
    color: #fff;
    margin-bottom: 30px;
  }
`;

export const MainSection = styled.section`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 50px 250px;
  background-color: #f2f2f2;

  @media (max-width: 1300px) {
    padding: 50px 100px;
  }

  @media (max-width: 650px) {
    padding: 20px;
  }
`;

export const SkillsSection = styled.section`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 50px 250px;
  background-color: #ffffff;

  @media (max-width: 1300px) {
    padding: 50px 100px;
  }

  @media (max-width: 650px) {
    padding: 20px;
  }
`;

export const AcademicSection = styled.section`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 50px 250px;
  background-color: #f2f2f2;

  @media (max-width: 1300px) {
    padding: 50px 100px;
  }

  @media (max-width: 650px) {
    padding: 20px;
  }
`;

export const ProfessionalSection = styled.section`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 50px 250px;
  background-color: #ffffff;

  @media (max-width: 1300px) {
    padding: 50px 100px;
  }

  @media (max-width: 650px) {
    padding: 20px;
  }
`;

export const WelcomeDiv = styled.div`
  gap: 5px;
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const WelcomeTitle = styled.h1`
  color: #104467;
`;

export const WelcomeText = styled.span`
  color: #104467;
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const EditIconContainer = styled.button`
  background: none;
  border: none;
  color: #104467;

  &:hover {
    cursor: pointer;
  }
`;

export const PersonalInformationDiv = styled.div``;

export const InfoList = styled.ul`
  list-style-type: none;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 20px;
`;

export const InputRow = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  margin: 15px 0;
  gap: 10px;
  justify-content: space-between;

  @media (max-width: 650px) {
    grid-template-columns: repeat(1, 1fr);
  }
`;

export const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 400px;
  text-align: center;

  @media (max-width: 1300px) {
    min-width: 200px;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
`;

export const CustomButton = styled.button`
  background: ${(props) => (props.alt ? "white" : "#104467")};
  border: ${(props) => (props.alt ? "1px solid #104467" : "none")};
  border-radius: 3px;
  cursor: pointer;
  padding: 10px;
  margin: 3px;
  color: ${(props) => (props.alt ? "#104467" : "white")};

  &:hover {
    background: ${(props) =>
      props.alt ? "rgb(0, 0, 0, 0.1)" : "rgb(9, 41, 61)"};
  }

  &:disabled {
    background: #afafaf;
    border: none;
    color: white;
    cursor: default;
  }
`;

export const CheckboxesDiv = styled.form`
  display: flex;
  flex-direction: column;
  margin-top: 30px;
  gap: 30px;
`;

export const CourseDiv = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 20px;
`;

export const InputContainerCourse = styled.div`
  display: flex;
  flex-direction: column;
  width: 80%;
`;

export const InputContainerYear = styled.div`
  display: flex;
  flex-direction: column;
  width: 20%;
`;
